import React, { useEffect, useState } from 'react';
import NavRoutes from './utils/NavRoutes';
// import Header from './components/Header';
import { BrowserRouter } from 'react-router-dom';
import MusUtils from './utils/Utilities';

export default function App() {
  
  useEffect(() => { 
    window.scrollTo(0, 0);
    let theme = MusUtils.getTheme();
    MusUtils.changeTheme(theme);
  },[]);

  return (
    <div style={{height:'100vh'}}>
      <BrowserRouter basename={''}>
        <NavRoutes />
      </BrowserRouter>
    </div>
  );
}